import IMask from 'imask';
import { useRef, useState, useCallback, useEffect } from 'react';

/* eslint-disable no-underscore-dangle */


function useIMask(ref, _ref) {
  var _maskRef$current2, _maskRef$current3;

  var opts = _ref.opts,
      onAccept = _ref.onAccept,
      onComplete = _ref.onComplete;
  var maskRef = useRef(null);

  var _useState = useState(''),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = useState(''),
      unmaskedValue = _useState2[0],
      setUnmaskedValue = _useState2[1];

  var _useState3 = useState(),
      typedValue = _useState3[0],
      setTypedValue = _useState3[1];

  var handleSetValue = function handleSetValue(externalValue) {
    var mask = maskRef.current;
    if (mask) mask.value = externalValue;
    setValue(externalValue);
  };

  var handleSetUnmaskedValue = function handleSetUnmaskedValue(newUnmaskedValue) {
    var mask = maskRef.current;
    if (mask) mask.unmaskedValue = newUnmaskedValue != null ? newUnmaskedValue : '';
    setUnmaskedValue(newUnmaskedValue);
  };

  var handleSetTypedValue = function handleSetTypedValue(newTypedValue) {
    var mask = maskRef.current;
    if (mask) mask.newTypedValue = newTypedValue != null ? newTypedValue : '';
    setTypedValue(newTypedValue);
  };

  var privateDestroyMask = useCallback(function () {
    var _maskRef$current;

    (_maskRef$current = maskRef.current) == null ? void 0 : _maskRef$current.destroy();
    maskRef.current = null;
  }, []);
  var privateOnAccept = useCallback(function (event) {
    if (!maskRef.current || !ref.current) return;
    /**
     * Для получения корректного значения из IMask обращаемся к приватному value и unmaskedValue
     * Это помогает отображать корректный код страны при изменении
     */

    setTypedValue(maskRef.current.typedValue);
    setUnmaskedValue(maskRef.current._unmaskedValue);
    var nextValue = typeof maskRef.current.value === 'string' ? maskRef.current._value : maskRef.current.value.value;
    setValue(nextValue);

    if (event) {
      onAccept == null ? void 0 : onAccept(event, {
        value: maskRef.current._unmaskedValue,
        name: event == null ? void 0 : event.target.name,
        formattedValue: nextValue
      });
    }
  }, [onAccept, ref]);
  var privateOnComplete = useCallback(function (event) {
    var nextValue = typeof maskRef.current.value === 'string' ? maskRef.current._value : maskRef.current.value.value;

    if (maskRef.current) {
      onComplete == null ? void 0 : onComplete(event, {
        value: maskRef.current._unmaskedValue,
        name: event == null ? void 0 : event.target.name,
        formattedValue: nextValue
      });
    }
  }, [onComplete]);
  useEffect(function () {
    var el = ref == null ? void 0 : ref.current;
    if (!el || !(opts != null && opts.mask)) return privateDestroyMask();
    var mask = maskRef.current;

    if (!mask) {
      if (el && opts != null && opts.mask) {
        maskRef.current = IMask(el, opts);
        if (el.defaultValue !== maskRef.current._value) privateOnAccept();
      }
    } else {
      mask == null ? void 0 : mask.updateOptions(opts);
    }
  }, [opts, privateDestroyMask, privateOnAccept, ref]);
  useEffect(function () {
    if (!maskRef.current) return;
    var mask = maskRef.current;
    mask.on('accept', privateOnAccept);
    mask.on('complete', privateOnComplete);
    return function () {
      mask.off('accept', privateOnAccept);
      mask.off('complete', privateOnComplete);
    };
  }, [privateOnAccept, privateOnComplete]);
  useEffect(function () {
    return privateDestroyMask;
  }, [privateDestroyMask]);
  return {
    maskRef: maskRef,
    value: (maskRef == null ? void 0 : (_maskRef$current2 = maskRef.current) == null ? void 0 : _maskRef$current2._value) || value,
    setValue: handleSetValue,
    unmaskedValue: (maskRef == null ? void 0 : (_maskRef$current3 = maskRef.current) == null ? void 0 : _maskRef$current3._unmaskedValue) || unmaskedValue,
    setUnmaskedValue: handleSetUnmaskedValue,
    typedValue: typedValue,
    setTypedValue: handleSetTypedValue
  };
}

export { useIMask as default };
